import React from "react";
import Section from "../components/Section";
import ArticleCard from "../components/ArticleCard";
import articlesData from "../data/articles.json";

export default function Articles() {
  const [filter, setFilter] = React.useState<string | null>(null);
  const articles = articlesData.articles || [];

  const tags = Array.from(new Set(articles.flatMap((a: any) => a.tags || [])));

  const visible = filter ? articles.filter((a: any) => (a.tags || []).includes(filter)) : articles;

  return (
    <main className="min-h-screen">
      <Section title="Articles" eyebrow="notes & dispatches">
        <div className="mb-6 flex flex-wrap gap-2">
          <button
            onClick={() => setFilter(null)}
            className={`px-3 py-1.5 font-mono text-xs rounded-pill border transition ${
              filter ? "border-border-subtle text-text-muted" : "border-accent text-primary bg-accent-soft/30"
            }`}
          >
            All
          </button>
          {tags.map((t: string) => (
            <button
              key={t}
              onClick={() => setFilter(t)}
              className={`px-3 py-1.5 font-mono text-xs rounded-pill border transition ${
                filter === t ? "border-accent text-primary bg-accent-soft/30" : "border-border-subtle text-text-muted"
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {visible.map((a: any) => (
            <ArticleCard key={a.id} article={a} />
          ))}
        </div>
      </Section>
    </main>
  );
}
